import Phone from '@/components/Phone';

const PhonePage = () => {
  return <Phone />;
};

export default PhonePage;
